import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";

function OnsVerhaal() {
  return (
    <div className="grid grid-rows-[auto_1fr_auto] min-h-screen page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Ons verhaal Elektricien Arnhem - elektricieninarnhem026.nl"
        description="Wij geloven in innovatie, duurzaamheid en vakmanschap. Ontdek hoe wij de elektrotechnische sector vernieuwen met slimme oplossingen in Arnhem."
        image="/images/banner.png"
      />

      <Header />

      <div className="grid min-h-[calc(100vh-915px)] grid-cols-1 pt-6">
        <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
          <h1 className="font-bold text-black leading-[1.25] text-[40px] lg:text-[52px] mb-4 text-[28px] md:mb-5 md:text-[44px] text-[#17354A]">
            Ons verhaal
          </h1>
          <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] font-medium max-w-[100%] md:max-w-[62.5%] mb-12">
    Wij geloven in innovatie, duurzaamheid en vakmanschap. Ontdek hoe
    wij de elektrotechnische sector vernieuwen met slimme oplossingen in Arnhem.
  </div>

          <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
            <div>
              <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
                Onze visie
              </h2>
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
        De wereld van elektrotechniek verandert snel. Duurzaamheid en
        innovatie staan centraal in moderne installaties. Als
        vooruitstrevend elektrotechnisch bedrijf nemen wij onze
        verantwoordelijkheid om bij te dragen aan een duurzame toekomst.
        <br />
        <br />
        Wij geloven dat elke woning en elk bedrijfspand recht heeft op
        veilige, efficiënte en toekomstbestendige elektrische
        installaties. Door de nieuwste technologieën te combineren met
        vakkundig handwerk, creëren we oplossingen die niet alleen aan
        de huidige eisen voldoen, maar ook klaar zijn voor de toekomst.
      </p>
            </div>
            <div>
              <div className="relative">
                <img
                  alt="Elektrotechnische innovatie"
                  loading="lazy"
                  className="rounded-lg"
                  src="/images/mark.png"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-20 md:mb-[120px] lg:mb-40">
          <div className="mb-8 md:mb-12">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] mb-4 md:mb-5 text-[#17354A]">
              Onze missie
            </h2>
            <div className="max-w-[33rem]">
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
                elektricieninarnhem026.nl vernieuwt de elektrotechnische sector
                met expertise en innovatie. We maken complexe technologie
                toegankelijk en betaalbaar voor iedereen, waarbij kwaliteit en
                veiligheid voorop staan.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-[1fr] gap-8 md:grid-cols-[1fr_1fr] lg:gap-x-16">
            <div>
              <h5 className="font-bold text-black leading-[1.25] text-[18px] lg:text-[21px] mb-3 md:mb-4 text-[#17354A]">
                Vakkundig
              </h5>
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
                Onze gecertificeerde elektriciens combineren jarenlange ervaring
                met continue bijscholing. We werken volgens de laatste normen en
                gebruiken alleen A-kwaliteit materialen.
              </p>
            </div>

            <div>
              <h5 className="font-bold text-black leading-[1.25] text-[18px] lg:text-[21px] mb-3 md:mb-4 text-[#17354A]">
                Innovatief
              </h5>
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
                We blijven voorop lopen in de nieuwste ontwikkelingen, van
                slimme domotica tot energiebesparende oplossingen. Innovatie
                staat centraal in al onze diensten.
              </p>
            </div>

            <div>
              <h5 className="font-bold text-black leading-[1.25] text-[18px] lg:text-[21px] mb-3 md:mb-4 text-[#17354A]">
                Klantgericht
              </h5>
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
                We luisteren naar uw wensen en denken mee in oplossingen.
                Heldere communicatie en persoonlijke aandacht staan bij ons
                voorop, van offerte tot oplevering.
              </p>
            </div>

            <div>
              <h5 className="font-bold text-black leading-[1.25] text-[18px] lg:text-[21px] mb-3 md:mb-4 text-[#17354A]">
                Duurzaam
              </h5>
              <p className="text-[16px] md:text-[18px] text-[#17354A] leading-[1.56]">
                We adviseren en installeren energiezuinige oplossingen die
                bijdragen aan een duurzame toekomst. Van LED-verlichting tot
                laadpalen voor elektrische auto's.
              </p>
            </div>
          </div>
        </section>

        {/* Company Info Section */}
        <section className="mx-auto my-12 w-[calc(100%_-_40px)] max-w-[961px] md:my-[120px]">
          <h5 className="font-bold text-black leading-[1.25] text-[18px] lg:text-[21px] mb-4 text-[#17354A]">
            <span className="font-semibold">Onze gegevens</span>
          </h5>
          <div className="flex justify-between flex-col md:flex-row">
            <div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                elektricieninarnhem026.nl
              </div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                Laan van vollenhove 2935
              </div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                3706 AK Zeist
              </div>
            </div>
            <div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                KvK-nummer 93984707
              </div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                Btw-nummer: NL866593433B01
              </div>
            </div>
            {/* <div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                IBAN: NL01 RABO 0123 4567 89
              </div>
              <div className="text-[16px] md:text-[18px] text-[#17354A]">
                BIC: RABONL2U
              </div>
            </div> */}
          </div>
        </section>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default OnsVerhaal;
